import React, { useState } from 'react';
import './MobileChatInterface.css';

interface Message {
  id: string;
  type: 'question' | 'answer';
  content: string;
  timestamp: Date;
}

interface MobileChatInterfaceProps {
  messages: Message[];
  onSendMessage: (message: string) => void;
  onGenerateSummary: () => void;
  onShowSuggestions: () => void;
  onViewPDF: () => void;
  onSearchDocument: () => void;
}

const MobileChatInterface: React.FC<MobileChatInterfaceProps> = ({
  messages,
  onSendMessage,
  onGenerateSummary,
  onShowSuggestions,
  onViewPDF,
  onSearchDocument
}) => {
  const [inputValue, setInputValue] = useState('');

  const handleSend = () => {
    if (inputValue.trim()) {
      onSendMessage(inputValue);
      setInputValue('');
    }
  };

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  return (
    <div className="mobile-chat-container">
      {/* Chat History */}
      <div className="chat-history">
        {messages.map((message) => (
          <div
            key={message.id}
            className={`message ${message.type}`}
          >
            <div className="message-content">
              {message.content}
            </div>
            <div className="message-timestamp">
              {message.timestamp.toLocaleTimeString()}
            </div>
          </div>
        ))}
      </div>

      {/* Quick Actions Bar */}
      <div className="quick-actions">
        <button className="quick-action-btn" onClick={onGenerateSummary}>
          📊 Professional Summary
        </button>
        <button className="quick-action-btn" onClick={onShowSuggestions}>
          ❓ Question Suggestions
        </button>
        <button className="quick-action-btn" onClick={onViewPDF}>
          📄 View PDF
        </button>
        <button className="quick-action-btn" onClick={onSearchDocument}>
          🔍 Search Document
        </button>
      </div>

      {/* Chat Input */}
      <div className="chat-input-container">
        <div className="input-actions">
          <button className="input-action-btn">🎤</button>
          <button className="input-action-btn">📎</button>
          <button className="input-action-btn">🔍</button>
          <button className="input-action-btn">⚙️</button>
        </div>
        <div className="input-field-container">
          <textarea
            className="chat-input"
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            onKeyPress={handleKeyPress}
            placeholder="Ask a question about the document..."
            rows={1}
          />
          <button className="send-btn" onClick={handleSend}>
            Send
          </button>
        </div>
      </div>
    </div>
  );
};

export default MobileChatInterface; 